import { User } from "../../types";
import { admin, forecaster } from "./axios";
import { getAxiosInstance, UserGroup } from "./constants";
import { GetTrendsParams } from "./trends";
import { MAX_TRENDS_SIZE } from "../../constants/constants";

export const getBarGraphData = async (
  params: GetTrendsParams,
  user: User | null
) => {
  if (user === null) {
    throw new Error("User is not available");
  }

  const { group } = user!;
  if (!group) {
    console.error("Group Not Found");
    return;
  }

  const paramsAfterColorAnalysisRemoval = { ...params };
  delete paramsAfterColorAnalysisRemoval.colorAnalysis;
  delete paramsAfterColorAnalysisRemoval.level2Color;
  paramsAfterColorAnalysisRemoval.posts_per_trend = 1;
  paramsAfterColorAnalysisRemoval.pageSize = MAX_TRENDS_SIZE;
  paramsAfterColorAnalysisRemoval.page = 1;
  paramsAfterColorAnalysisRemoval.generic = true;

  try {
    const axiosInstance = getAxiosInstance(user.group as UserGroup);
    if (axiosInstance) {
      const response = await axiosInstance.get(`/trends`, {
        params: paramsAfterColorAnalysisRemoval,
      });
      const responseData = response?.data?.data?.trends?.map(
        //eslint-disable-next-line @typescript-eslint/no-explicit-any
        (trend: any) => trend.graphData
      );
      return responseData;
    } else {
      console.error("Group not found");
    }
  } catch (error) {
    console.error("Error fetching trends:", error);
    throw error;
  }
};
